export default __webpack_public_path__ + "static/media/ΦΑΕΕΕ_ΦΑ.bf7cb3f3.png";